import { initProfileReadme } from '~/users/profile/readme';

initProfileReadme();
